export const Bio = {
  name: "Sudhir Zuge",
  roles: ["Full Stack Developer", "Frontend Developer, Backend Developer"],

  description:
    "I am a Software Developer with 2+ years of experience in building large-scale web applications. My expertise lies in React.js, Redux, JavaScript, HTML5, and CSS3, along with proficiency in backend technologies such as Java, Spring Boot, Spring Security, and RESTful APIs also C#, ASP.NET Core, RESTful web api. I thrive on challenges and enjoy working on projects that push me beyond my comfort zone, allowing me to continuously learn and grow.",

  github: "https://github.com/sudhirzuge",
  email: "sudhirzuge2000@gmail.com",
  resume:
    "https://drive.google.com/file/d/1_J1vRWD_og9bu_eHS_FJfvaZ3MUxj3_g/view?usp=drivesdk",
  linkedin: "https://www.linkedin.com/in/sudhirzuge/",
  twitter: "https://x.com/sudhirzuge",
  leetcode: "https://leetcode.com/u/sudhirzuge/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },

      {
        name: "HTML5",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS3",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },

      {
        name: "Tailwindcss",
        image:
          "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "C#",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
      },

      {
        name: "ASP.NET Core",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/dotnetcore/dotnetcore-original.svg",
      },

      {
        name: "RESTful Web API",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/swagger/swagger-original.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },

      // {
      //   name: "Spring Boot",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/7/79/Spring_Boot.svg",
      // },

      // {
      //   name: "Spring Security",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/7/79/Spring_Boot.svg",
      // },

      // {
      //   name: "RESTful APIs",
      //   image:
      //     "https://uxwing.com/wp-content/themes/uxwing/download/web-app-development/rest-api-icon.png",
      // },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "Linux",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/35/Tux.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/0/01/Atos.svg",
    role: "Frontend Developer",
    company: "Atos",
    date: "Sept 2022 - Aug 2024",
    desc: "Client : SBMB ( Service Box Multi Brand ).Worked on feature development, implemented user interfaces, ensured a seamless user experience, and built and maintained responsive web applications using React.js.",
    skills: [
      "JavaScript",
      "React.js",
      "Redux.js",
      "Context API",
      "HTML5",
      "CSS3",
      "Jira",
      "Java",
      "SQL",
    ],
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/commons/a/a0/Wipro_Primary_Logo_Color_RGB.svg",
    role: "Project Engineer Intern",
    company: "Wipro",
    date: "Mar 2022 - May 2022",
    desc: "Completed a Java/J2EE project for requirement of academic graduation, during the internship i learn to make standalone console based application. Received positive feedback for excellent work.",
    skills: ["Core Java"],
  },
];

// https://media.licdn.com/dms/image/v2/C4D0BAQGObigiUGPxhA/company-logo_200_200/company-logo_200_200/0/1631354037878?e=2147483647&v=beta&t=2v7YCVQjrj5mzDCt7v0aFkMmXIKXTeZDkCf4lauwjrU
// https://www.sunbeaminfo.com/img/new/sunbeamnewactslogo.png

export const education = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C4D0BAQGObigiUGPxhA/company-logo_200_200/company-logo_200_200/0/1631354037878?e=2147483647&v=beta&t=2v7YCVQjrj5mzDCt7v0aFkMmXIKXTeZDkCf4lauwjrU",
    school: "Sunbeam Institute of Information Technology, Pune",
    date: "Aug 2024 - Feb 2025",
    grade: "CDAC CCEE EXAM : 71%",
    desc: "I have upskilled myself through the C-DAC program, gaining expertise in a wide range of technologies. This journey has enhanced my ability to build robust and scalable applications across the tech stack.",
    degree: " Post Graduation Diploma in Advanced Computing - CDAC ACTS Pune",
  },
  {
    id: 1,
    img: "https://www.avcoe.org/images/logo/avcoe-engineering-logo.png",
    school: "Amrutvahini College Of Engineering, Sangamner ",
    date: "Jun 2018 - Jul 2022",
    grade: "8.88 CGPA",
    desc: "My graduation journey helped me build a strong analytical mindset and problem-solving skills, which I have effectively applied in my software development career.",
    degree: "Bachelor of Engineering - Savitribai Phule Pune University",
  },
];

export const projects = [
  {
    id: 0,
    title: "BankEase",
    date: " ",
    description:
      "◦ BankEase is a full-stack web application designed to streamline core banking operations and enhance the customer-staff experience. Key features include : Account Management : Easy creation and maintenance of savings and current accounts. Transaction Processing : Secure handling of deposits, withdrawals, and fund transfers. Advanced Reporting : Auto-generated statements and analytics for informed decisions. Secure Access : Role-based authentication and protected data operations. ",
    image: " ",
    tags: [
      "React.js",
      "JavaScript",
      "Spring Boot",
      "Spring Security",
      "Rest API's",
      "MySQL",
    ],
    category: "Full Stack Apps",
    github: "https://github.com/sudhirzuge/Banking-Management-System",
    webapp: " ",
  },

  {
    id: 1,
    title: "Flavour Express",
    date: "Nov 2024 - Dec 2024",
    description:
      "Flavour Express is a frontend application built using Swiggy's live api having search, login, add to cart functionality",
    image:
      "https://github.com/sudhirzuge/sudhir-portfolio/blob/main/flavour%20express%20search%20feature.png?raw=true",
    tags: ["React.js, TailWind, Axios, Formik"],
    category: "Frontend Apps",
    github: "https://github.com/sudhirzuge/Flavour-Express",
    webapp: " ",
  },

  {
    id: 2,
    title: "CureAll",
    date: "Feb 2025 - Feb 2025",
    description:
      "CureAll is a full-stack web application designed to streamline patient-doctor interactions across multiple hospitals. Key features include: Appointment Scheduling : Allowing patients to book and manage appointments efficiently. Prescription Management : Secure handling of prescriptions and medical records. Secure Data Handling : Ensuring privacy and compliance with healthcare standards. ",
    image:
      "https://github.com/sudhirzuge/sudhir-portfolio/blob/main/CureAll%20Admin.png?raw=true",
    tags: [
      "React.js",
      "Tailwind CSS",
      "JavaScript",
      "C#",
      "ASP.NET Core",
      "RESTful Web API",
      "SQL Server",
      // "Spring Boot",
      // "Spring Security",
      // "Spring Data JPA",
      // "MySQL",
    ],
    category: "Full Stack Apps",
    github: "https://github.com/sudhirzuge/CureAll",
    webapp: " ",
  },

  {
    id: 3,
    title: "Todo Management",
    date: "Mar 2025 - Mar 2025",
    description:
      "Todo Management is a full stack application where i have implemented various feature JWT, Spring Security, Role based Registration & Login",
    image:
      "https://github.com/sudhirzuge/sudhir-portfolio/blob/main/Todo%20role-admin.png?raw=true",
    tags: [
      "Spring Boot",
      "Spring Security",
      "Spring Data JPA",
      "JWT",
      "React.Js",
      "MySQL",
    ],
    category: "Backend Apps",
    github: "https://github.com/sudhirzuge/Todo-Management",
    webapp: " ",
  },

  {
    id: 4,
    title: "Employee Management System",
    date: "Jan 2025 - Jan 2025",
    description:
      "Employee Management System is a Simple crud operation full stack application having role based access user & admin",
    image:
      "https://github.com/sudhirzuge/sudhir-portfolio/blob/main/EMS%20Admin.png?raw=true",
    tags: ["React.js", "Bootstrap", "Spring Boot ", "Spring Data Jpa", "MySQL"],
    category: "Full Stack Apps",
    github: "https://github.com/sudhirzuge/Employee-Management-System",
    webapp: " ",
  },
];
